import type { VisualizationT } from '@mentimeter/question-modules-types';
import { withTheme } from '@mentimeter/ragnar-react';
import * as React from 'react';

interface SvgT {
  width?: string;
  height?: string;
  viewBox?: string | undefined;
  preserveAspectRatio?: string;
  overflow?: string;
  handleClick?: () => void;
  children: React.ReactNode;
}
interface PropsT extends SvgT, VisualizationT {}

export const SvgElement = withTheme(
  ({
    width = '100%',
    height = '100%',
    viewBox = '0 0 960 540',
    preserveAspectRatio = 'xMidYMid',
    overflow = 'visible',
    handleClick,
    theme,
    children,
    ...rest
  }: PropsT) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        preserveAspectRatio={preserveAspectRatio}
        style={{ overflow }}
        onClick={handleClick}
        fontFamily={theme.fonts.body}
        {...rest}
      >
        {children}
      </svg>
    );
  },
);
